const SET_STATE = 'scratch-gui/assistant/SET_STATE';

const HOMEWORK_CORRECTED = 'homeworkCorrected';


const initialState = {
    [HOMEWORK_CORRECTED]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_STATE:
        return Object.assign({}, state, {
            [action.key]: action.value
        });
    default:
        return state;
    }
};
const setState = function (key, value) {
    return {
        type: SET_STATE,
        key: key,
        value: value
    };
};

const setHomeworkCorrected = function () {
    return setState(HOMEWORK_CORRECTED, true);
};


export {
    reducer as default,
    initialState as assistantInitialState,
    setHomeworkCorrected
};
